import { haversineDistance } from '../../../../javascript/utils.js';

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll(
		'.wp-block-cancan-restaurants-table'
	);

	blocks.forEach((block) => {
		const loader = block.querySelector('.loader');
		const rowsWrapper = block.querySelector('.restaurant-rows-wrapper');
		const rows = Array.from(block.querySelectorAll('.restaurant-row'));

		// Proximity sorting
		if (navigator.geolocation && rows.length > 0) {
			if (loader) loader.classList.remove('hidden');

			navigator.geolocation.getCurrentPosition(
				(position) => {
					const userLat = position.coords.latitude;
					const userLng = position.coords.longitude;

					const rowsWithDistance = rows.map((row) => {
						const lat = parseFloat(row.dataset.lat);
						const lng = parseFloat(row.dataset.lng);

						return {
							element: row,
							distance:
								isNaN(lat) || isNaN(lng)
									? Infinity
									: haversineDistance(
										userLat,
										userLng,
										lat,
										lng
									),
						};
					});

					rowsWithDistance.sort((a, b) => a.distance - b.distance);

					// Re-append in new order
					rowsWithDistance.forEach((item) => {
						rowsWrapper.appendChild(item.element);
					});

					if (loader) loader.classList.add('hidden');
				},
				(error) => {
					console.warn(
						'[Restaurants Table] Geolocation error:',
						error
					);
					if (loader) loader.classList.add('hidden');
				},
				{
					enableHighAccuracy: false,
					timeout: 5000,
					maximumAge: 300000,
				}
			);
		}

		rows.forEach((row) => {
			const details = row.querySelector('.restaurant-details');
			if (!details) return;

			// Don't propagate click event on links inside details
			details.querySelectorAll('a').forEach((link) => {
				link.addEventListener('click', (e) => {
					e.stopPropagation();
				});
			});

			const open = () => {
				// Close all other rows inside this block
				rows.forEach((otherRow) => {
					if (otherRow !== row) {
						const otherDetails = otherRow.querySelector(
							'.restaurant-details'
						);
						if (!otherDetails) return;

						gsap.killTweensOf(otherDetails);

						gsap.to(otherDetails, {
							height: 0,
							duration: 0.3,
							ease: 'power2.inOut',
							overwrite: 'auto',
							onComplete: () => {
								gsap.set(otherDetails, {
									visibility: 'hidden',
								});
							},
						});

						otherRow.classList.remove('is-open');
						otherRow.setAttribute('aria-expanded', 'false');
					}
				});

				// Open this row
				gsap.killTweensOf(details);

				gsap.to(details, {
					height: 'auto',
					duration: 0.35,
					ease: 'power2.out',
					overwrite: 'auto',
					onStart: () => {
						gsap.set(details, { visibility: 'visible' });
					},
				});

				row.classList.add('is-open');
				row.setAttribute('aria-expanded', 'true');
			};

			const close = () => {
				gsap.killTweensOf(details);

				gsap.to(details, {
					height: 0,
					duration: 0.3,
					ease: 'power2.inOut',
					overwrite: 'auto',
					onComplete: () => {
						gsap.set(details, { visibility: 'hidden' });
					},
				});

				row.classList.remove('is-open');
				row.setAttribute('aria-expanded', 'false');
			};

			const toggle = () => {
				row.classList.contains('is-open') ? close() : open();
			};

			/* -------------------------
			   Click
			-------------------------- */
			row.addEventListener('click', toggle);

			/* -------------------------
			   Keyboard
			-------------------------- */
			row.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggle();
				}
			});
		});

		/* -------------------------
		   Resize recalculation
		-------------------------- */
		window.addEventListener('resize', () => {
			rows.forEach((row) => {
				if (row.classList.contains('is-open')) {
					const details = row.querySelector('.restaurant-details');
					if (details) gsap.set(details, { height: 'auto' });
				}
			});
		});
	});
});
